import { Component, input, OnInit } from "@angular/core";
import { TemporaryArea } from "@models/map/market-filter.model";
import { CapitalizePipe } from "ev-core";
import { ILatLng } from "polydraw";
import { EvAreaType } from "src/app/infopage/models/area-type.enum";

const MAX_ALLOWED_SELECTIONS = 5;
interface SelectionData {
    type: SelectionType;
    label: string;
    position: number;
}

enum SelectionType {
    Polygon = 1,
    Area = 2,
}

@Component({
    selector: "subscription-selection",
    templateUrl: "./subscription-selection.component.html",
    styleUrl: "./subscription-selection.component.scss",
})
export class SubscriptionSelectionComponent implements OnInit {
    polygons = input<ILatLng[][][]>([]);
    areas = input<TemporaryArea[]>([]);

    MAX_ALLOWED_SELECTIONS = MAX_ALLOWED_SELECTIONS;
    SelectionType = SelectionType;

    selectionData: SelectionData[] = [];
    totalLength = 0;

    ngOnInit() {
        const combinedSelections = [
            ...this.areas().map((x, index) => ({
                type: SelectionType.Area,
                label: this.getAreaLabel(x),
                position: index + 1,
            })),
            ...this.polygons().map((x, index) => ({
                type: SelectionType.Polygon,
                label: "Tegnet område",
                position: this.areas.length > 0 ? this.areas.length + index + 1 : 1,
            })),
        ];
        this.totalLength = combinedSelections.length;
        this.selectionData = combinedSelections.slice(0, MAX_ALLOWED_SELECTIONS);
    }

    getAreaMappedType(areaTypeId: number) {
        return this.getAreaTypeNameSingular(Number(areaTypeId));
    }

    getAreaLabel(area: TemporaryArea) {
        if (area.areaType === EvAreaType.PostcodeArea) {
            return area.number + " " + CapitalizePipe.transform(area.name);
        }
        return CapitalizePipe.transform(area.name);
    }

    getAreaTypeNameSingular(areaTypeId: number): string {
        switch (areaTypeId) {
            case 5:
                return "Poststed";
            case 6:
                return "Grunnkrets";
            case 7:
                return "Kommune";
            case 8:
                return "Fylke";
            case 9:
                return "Delbydel";
            case 10:
                return "Kommunedel";
            case 11:
                return "Bydel";
            default:
                return areaTypeId.toString();
        }
    }
}
